/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingHolderDetailConfig } from '../../config/loading.config';
export interface ILoadingHolderDetailPluginMethods extends IPluginMethodMap {
  getLoadingHolderDetailSync(args?: any): any;
}

export class LoadingHolderDetailPlugin implements IAgentPlugin {
  readonly methods: ILoadingHolderDetailPluginMethods;

  constructor() {
    this.methods = {
      getLoadingHolderDetailSync: this.getLoadingHolderDetailSync.bind(this),
    };
  }

  getLoadingHolderDetailSync(args?: any) {
    return {
      loading: loadingHolderDetailConfig,
    };
  }
}
